import type * as models from 'pkg/api/models';
import { isPlayer } from 'pkg/api/models/membership/guards';
import { isMissingRequiredInformation } from 'pkg/api/models/user/guards';

// Family mode only makes sense when there is more than one child to aggregate.
const MinimumFamilyModeWards = 2;

/**
 * Returns the wards that have at least one group in the current organization,
 * i.e. the children family mode aggregates over.
 */
export function familyModeWards(wards: models.user.User[]): models.user.User[] {
	return wards.filter((w) => w.groups?.length > 0);
}

// Returns the children who are members of the given group.
export function childrenInGroup(
	children: models.user.User[],
	groupId: number
): models.user.User[] {
	return children.filter((c) => c.groups?.some((g) => g.groupId === groupId));
}

// Returns the first child who plays in any group and is missing information
// the organization requires, mirroring the per-child check in team context.
export function firstChildMissingRequiredInformation(
	children: models.user.User[]
): models.user.User | undefined {
	return familyModeWards(children).find(
		(c) => c.groups?.some((g) => isPlayer(g)) && isMissingRequiredInformation(c)
	);
}

export function isFamilyModeEligible(wards: models.user.User[]): boolean {
	return familyModeWards(wards).length >= MinimumFamilyModeWards;
}
